import styled from 'styled-components';

export const WelcomeOfferStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-size: auto;
  min-height: 90px;
  padding: 20px;

  .toast-fixed {
    .green-dark-box {
      &.floating-wrapper {
        top: 80px;
      }
    }
  }

  @media (max-width: 480px) {
    padding: 8px 20px;
  }

  .left-content {
    display: flex;
    align-items: center;

    @media (max-width: 480px) {
      width: 75%;
    }
  }

  .custom-toast {
    width: 200px;
    height: 19px;
    font-size: 15px;
    font-weight: 700;
    line-height: 19px;
    letter-spacing: 0em;
    text-align: center;
    background: #66BB6A;
    color: #fff;
    border-radius: 5px;
  }

  .image-style {
    width: 50px;
    height: 50px;
    padding: 0px 0px 0.0020904541015625px 0px;
  }

  .title {
    font-size: 24px;
    margin-bottom: 10px;
  }

  .title-subtitle-container {
    display: flex;
    flex-direction: column;
    padding-left: 20px;

    @media (max-width: 480px) {
      width: 80%;
    }
  }

  .subtitle {
    font-size: 16px;
    margin-right: 10px;
    display: block;
  }

  .title-above-subtitle {
    font-size: 24px;
    font-weight: 600;
    letter-spacing: 0px;
    text-align: left;
    display: block;
  }

  .promo-code {
    width: 130px;
    height: 44px;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    font-weight: bold;
    color: #388E3C;
    background-color: white;
    border-radius: 8px;
    border: 1px solid #388E3C;
    cursor: pointer;

    img {
      width: 20px !important;
    }
  }

  @media (max-width: 480px) {
    .image-style {
      width: 25px;
      height: 25px;
      padding: 0px;
    }
    .title-above-subtitle {
      font-size: 14px;
      font-weight: 600;
      display: block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .toast-fixed {
      .green-dark-box {
        &.floating-wrapper {
          top: 130px;
        }
      }
    }
    .promo-code {
      width: 30%;
      height: 35px;

      img {
        width: 13px !important;
      }
    }

    .subtitle {
      font-size: 12px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .promo-code-text {
      font-size: 10px;
    }
  }

  @media (max-width: 390px) {
    .image-style {
      width: 25px;
      height: 25px;
      padding: 0px;
    }
    .title-above-subtitle {
      font-size: 13px;
      font-weight: 600;
      display: block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .toast-fixed {
      .green-dark-box {
        &.floating-wrapper {
          top: 120px;
        }
      }
      .promo-code {
        width: 30%;
        height: 35px;

        img {
          width: 13px !important;
        }
      }

      .subtitle {
        font-size: 12px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .promo-code-text {
        font-size: 10px;
      }
    }
  }

  @media (max-width: 375px) {
    .image-style {
      width: 25px;
      height: 25px;
      padding: 0px;
    }
    .title-above-subtitle {
      font-size: 13px;
      font-weight: 600;
      display: block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .toast-fixed {
      .green-dark-box {
        &.floating-wrapper {
          top: 120px;
        }
      }
      .promo-code {
        width: 30%;
        height: 35px;

        img {
          width: 12px !important;
        }
      }

      .subtitle {
        font-size: 10px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .promo-code-text {
        font-size: 10px;
      }
    }
  }

  @media (max-width: 360px) {
    .image-style {
      width: 25px;
      height: 25px;
      padding: 0px;
    }
    .title-above-subtitle {
      font-size: 13px;
      font-weight: 600;
      display: block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .toast-fixed {
      .green-dark-box {
        &.floating-wrapper {
          top: 120px;
        }
      }
      .promo-code {
        width: 30%;
        height: 35px;

        img {
          width: 12px !important;
        }
      }

      .subtitle {
        font-size: 12px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .promo-code-text {
        font-size: 10px;
      }
    }
  }
`;
